import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProcessRunService {
  @Output() fetchNewRes = new EventEmitter();
  constructor(private http: HttpClient) { }
  @Output() fetchInprocess = new EventEmitter();
  getClientes(app) {

    let ap = "";
    if (app == 'auc') {
      ap = 'AucClients';
    } else if (app == 'both') {
      ap = '';
    } else {
      ap = 'AncClients';

    }
    console.log(ap);
    return this.http.get<clients>(`/api/Client/${ap}`)
  }

  async processClient(app, client_id, originalClientCode='') {
   let url = "";
   // if (originalClientCode == "ADF-ANC") {
  
   //  url = "/api/ScheduledJob/ProcessAncNew/" + client_id

   //} else {

     if (app == 'auc') {
       url = "/api/ScheduledJob/ProcessAucCustomer/" + client_id
     } else {
       url = "/api/ScheduledJob/ProcessAncNew/" + client_id
     }

   //}
   //console.log(url);
   return await this.http.get(url).toPromise();

  }

  getPInrocessRUns() {
    return this.http.get("/api/ProcessRun/InProgress");
  }

  meessageOfSuccess: string = "Ads has been successfully processed.";

}
export interface clients {
  clientID: number;
  name: string;
  address?: any;
  fileName?: any;
  enabled: boolean;
  originalClientID: number;
  originalClientCode: string;
  utmEnabled: boolean;
  apiEnabled: boolean;
  verbose: boolean;
  domain?: any;
  useZData: boolean;
  outputType: string;
  errorMsgProcess?: string;
  productId: number
  productCode: string
  productName: string
}
export interface inprocess{
  id: number
  processRunId: number
  startTime: string
  endTime: string
  status: string
  clientId: number
  clientName: string
  outputType: string
}

export interface Iresult {
  success: boolean,
  msg: string,
  client: string,
  clientID: number,
  VisualisationFileName: string
  verbose: boolean
}
